import './Tag.css'

export default function Tag({color, text}) {
  return (
    <div className={`tag tag${color}`}>
        <span className='tagText'>{text}</span>
    </div>
  )
}